import React, { useState } from "react";
import axios from "axios";

const Delete = ({ itemId, apiEndpoint, onDelete, onClose, deleteMessage }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await axios.delete(`${apiEndpoint}/${itemId}`);
      if (response.status === 200) {
        await onDelete(); // Wait for data refresh
        onClose();
      } else {
        setError("Failed to delete the item. Please try again.");
      }
    } catch (error) {
      setError(error.response?.data?.message || 
               error.response?.data?.error || 
               "An error occurred while deleting the item.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Confirm Deletion</h2>
      <p className="my-4">{deleteMessage}</p>
      {error && (
        <p className="text-red-500 text-sm">{error}</p>
      )}
      <div className="flex justify-end gap-4">
        <button
          onClick={handleDelete}
          className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 
                   disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
          disabled={loading}
        >
          {loading ? (
            <span className="flex items-center gap-2">
              <span className="animate-pulse">Deleting...</span>
            </span>
          ) : (
            "Yes, Delete"
          )}
        </button>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 
                   transition-colors"
          disabled={loading}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default Delete;